import React, { useEffect, useState } from "react";
import GlobalConsts from "../Constants/GlobalConsts";
import { useDispatch } from "react-redux";
import * as AuthActions from "../../Redux/Auth/AuthActions";


function ThemeToggler() {
    const dispatch = useDispatch();
    const [theme, setTheme] = useState(GlobalConsts.DARK);

    useEffect(() => {
        if (localStorage.theme === GlobalConsts.LIGHT || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
            setTheme(GlobalConsts.DARK);
            document.documentElement.classList.add('dark')
        } else {
            document.documentElement.classList.remove('dark')
        }
        dispatch(AuthActions.changeTheme(theme));
    }, [dispatch, theme])

    async function toggleTheme() {

        setTheme(localStorage.getItem('theme'));
        if (theme === GlobalConsts.LIGHT) {
            setTheme(GlobalConsts.DARK);
            document.documentElement.classList.add(GlobalConsts.DARK);
        } else {
            setTheme(GlobalConsts.LIGHT);
            document.documentElement.classList.remove(GlobalConsts.DARK);
        }
        localStorage.setItem('theme', theme);

    }

    return (
        <div className="flex">
            <button type="button"
                onClick={toggleTheme}
                className="rounded-full dark:bg-gray-800 p-1 dark:text-gray-400 dark:hover:text-white focus:outline-none dark:focus:ring-transparent dark:focus:ring-offset-2 focus:ring-offset-transparent text-gray-700">
                <span className="sr-only">View notifications</span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d={theme === GlobalConsts.LIGHT ? "M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" : "M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"} />
                </svg>
            </button>
        </div>
    );
}

export default ThemeToggler;
